import { useEffect } from 'react';

export default function Livraison() {
  useEffect(() => {
    document.title = 'Livraison & Frais de port – Mondial Relay | Les Carnets de Lolotte';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Informations de livraison Les Carnets de Lolotte : expédition via Mondial Relay, frais de port 4,20 € offerts dès 15 €, délai 2-3 jours de fabrication. Livraison France et Europe.');
    }

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Livraison & Frais de port – Les Carnets de Lolotte',
      description: 'Informations de livraison Les Carnets de Lolotte : expédition via Mondial Relay, frais de port 4,20 € offerts dès 15 €, délai 2-3 jours de fabrication.',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/livraison`,
      publisher: {
        '@type': 'Organization',
        name: 'Les Carnets de Lolotte',
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(248,237,234,0.9), rgba(248,237,234,0.9)), url('https://public.readdy.ai/ai/img_res/754865ddc791efeaf5c5fd2332176954.jpg')`
        }}
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-6xl md:text-7xl font-bold mb-6 text-[#B97A72]" style={{ fontFamily: 'Allura, cursive' }}>
            Livraison & Frais de port
          </h1>
          <p className="text-xl md:text-2xl text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Playfair Display, serif' }}>
            Vos créations artisanales livrées avec soin 💌
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-[#FAF9F8]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Livraison artisanale */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              ✨ Livraison artisanale avec soin
            </h2>
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-[#F8EDEA]">
              <p className="text-lg text-[#6B5E5A] leading-relaxed mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Toutes les créations des <em>Carnets de Lolotte</em> sont réalisées, emballées et expédiées avec le plus grand soin depuis mon atelier du sud de la France 🌸
              </p>
              <p className="text-lg text-[#6B5E5A] leading-relaxed mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Chaque ange, chaque pièce, est plié et protégé à la main, pour arriver chez vous en parfait état.
              </p>
              <p className="text-lg text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Les envois sont effectués via <strong className="text-[#B97A72]">Mondial Relay</strong>, un service fiable, pratique et économique, avec suivi en ligne.
              </p>
            </div>
          </div>

          {/* Délais */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              💌 Délais de fabrication et d'expédition
            </h2>
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-[#F8EDEA]">
              <ul className="space-y-4 text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <li className="flex items-start">
                  <span className="text-[#B97A72] mr-3">•</span>
                  Chaque article est fabriqué sur commande dans un délai de <strong className="text-[#B97A72]">2 à 3 jours ouvrés</strong>.
                </li>
                <li className="flex items-start">
                  <span className="text-[#B97A72] mr-3">•</span>
                  Une fois prêt, le colis est déposé dans un <strong className="text-[#B97A72]">point Mondial Relay</strong> proche de l'atelier.
                </li>
                <li className="flex items-start">
                  <span className="text-[#B97A72] mr-3">•</span>
                  Vous recevrez un <strong className="text-[#B97A72]">numéro de suivi</strong> pour suivre votre commande jusqu'à son point de retrait.
                </li>
              </ul>
            </div>
          </div>

          {/* Frais de port */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              💶 Frais de port
            </h2>
            <div className="bg-gradient-to-br from-[#F8EDEA] to-white rounded-2xl p-8 shadow-lg border-2 border-[#C49B86]">
              <div className="text-center mb-6">
                <p className="text-2xl font-bold text-[#B97A72] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  📦 Frais de port fixes : 4,20 € via Mondial Relay
                </p>
                <p className="text-3xl font-bold text-[#C49B86] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                  🎁 Frais de port offerts dès 15 € d'achat !
                </p>
                <p className="text-lg text-[#6B5E5A] italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                  <em>(Exemple : à partir de trois lots d'anges ou plusieurs créations, la livraison devient gratuite 💕)</em>
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 mt-6">
                <p className="text-lg text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  💬 Les commandes sont livrées dans le <strong className="text-[#B97A72]">point relais le plus proche</strong> de l'adresse indiquée.
                  Si vous souhaitez un relais spécifique, il est possible de le préciser lors de votre commande ou par message après paiement.
                </p>
              </div>
            </div>
          </div>

          {/* Emballage responsable */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              🌿 Emballage responsable
            </h2>
            <div className="bg-white rounded-2xl shadow-lg border-2 border-[#C49B86]/20 p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#F8EDEA] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-gift-line text-2xl text-[#C49B86]"></i>
                </div>
                <h3 
                  className="text-2xl font-bold text-[#C49B86]"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  Emballage soigné
                </h3>
              </div>
              <p 
                className="text-[#6B5E5A] leading-relaxed"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                Vos créations sont emballées avec le plus grand soin dans du papier de soie et protégées pour le transport. 
                Chaque commande est préparée à la main avec attention.
              </p>
            </div>
          </div>

          {/* Délais de réception */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              🕰️ Délais moyens de réception
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#F8EDEA] text-center">
                <div className="w-16 h-16 bg-[#B97A72] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                  France métropolitaine
                </h3>
                <p className="text-lg text-[#B97A72] font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  3 à 5 jours ouvrés après expédition
                </p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#F8EDEA] text-center">
                <div className="w-16 h-16 bg-[#C49B86] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-earth-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Union européenne
                </h3>
                <p className="text-lg text-[#B97A72] font-bold mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  5 à 8 jours ouvrés
                </p>
                <p className="text-sm text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  (sélection de pays couverts par Mondial Relay)
                </p>
              </div>
            </div>
            <div className="mt-6 text-center">
              <p className="text-lg text-[#6B5E5A] italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                <em>En période de fêtes, prévoyez un léger allongement des délais.</em>
              </p>
            </div>
          </div>

          {/* Résumé */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              🌸 En résumé
            </h2>
            <div className="bg-gradient-to-r from-[#F8EDEA] to-[#FAF9F8] rounded-2xl p-8 shadow-lg border-2 border-[#C49B86]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-3">
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-[#B97A72] rounded-full mr-3"></span>
                    <span className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Fabrication : 2 à 3 jours
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-[#B97A72] rounded-full mr-3"></span>
                    <span className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Livraison : Mondial Relay
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-[#B97A72] rounded-full mr-3"></span>
                    <span className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Suivi en ligne inclus
                    </span>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-[#C49B86] rounded-full mr-3"></span>
                    <span className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Frais de port : 4,20 €
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-[#C49B86] rounded-full mr-3"></span>
                    <span className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Offerts dès 15 € d'achat
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-[#C49B86] rounded-full mr-3"></span>
                    <span className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Livraison en France et Europe
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Encadré final */}
          <div className="text-center">
            <div className="bg-[#B97A72] text-white rounded-2xl p-8 shadow-lg">
              <p className="text-xl leading-relaxed italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                💕 <em>Merci de soutenir le travail artisanal et les créations faites main.</em>
              </p>
              <p className="text-xl leading-relaxed italic mt-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                <em>Chaque commande est préparée avec le cœur et envoyée avec soin.</em>
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}